import _defineProperty from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getMaterialCityDetail } from '../api/index.js';
import { getCityMateriaBranchList } from '@/api/manageCenter';
export default {
  name: 'materialSelectDrawer',
  data: function data() {
    return _defineProperty(_defineProperty({
      form: {
        material_id: '',
        name: '',
        material_type: [],
        print_type: '1',
        branch_office_id: [],
        sort: '',
        have_stock_count: '1',
        page: 1,
        pagesize: 20
      },
      materialTypeList: [{
        value: '3',
        label: '卡套'
      }, {
        value: '4',
        label: '券套'
      }, {
        value: '5',
        label: '手提袋'
      }, {
        value: '6',
        label: '宣传册'
      }, {
        value: '7',
        label: '画册'
      }],
      dataList: [],
      pages: {
        page: 1,
        pagesize: 20,
        totalCount: 0
      },
      selection: []
    }, "dataList", []), "branchCompanyList", []);
  },
  created: function created() {
    this.getBranchCompany();
    this.getList();
  },
  methods: {
    getList: function getList() {
      var _this = this;
      getMaterialCityDetail(this.form).then(function (res) {
        _this.dataList = res.data.list;
        _this.pages = res.pages || {};
      });
    },
    getBranchCompany: function getBranchCompany() {
      var _this2 = this;
      getCityMateriaBranchList().then(function (res) {
        _this2.branchCompanyList = res.data.list || [];
      });
    },
    sortChange: function sortChange(_ref2) {
      var column = _ref2.column,
        prop = _ref2.prop,
        order = _ref2.order;
      if (!order) {
        this.form.sort = '';
      } else {
        this.form.sort = "".concat(order === 'ascending' ? '' : '-').concat(prop);
      }
      this.getList();
    },
    search: function search() {
      this.form.page = 1;
      this.getList();
    },
    reset: function reset() {
      this.$refs.form.resetFields();
      this.form.material_type = [];
      this.search();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.selection = val;
    },
    handleConfirm: function handleConfirm() {
      if (!this.selection.length) {
        this.$message.warning('请至少选择一个物料');
        return;
      }
      this.$emit('selected', this.selection);
    },
    handleClose: function handleClose() {
      this.$emit('close');
    },
    currentChange: function currentChange(val) {
      this.form.page = val;
      this.getList();
    },
    sizeChange: function sizeChange(val) {
      this.form.pagesize = val;
      this.form.page = 1;
      this.getList();
    }
  }
};